import React from 'react'
import PropTypes from 'prop-types'

function Summary(props) {
  const { step, price, currency, mobile, inline, totalAmount, totalFee, fieldSizes, selectedSize, 
    selectedDate, selectedDuration, selectedInterval } = props
  const selectedFields = fieldSizes[selectedSize]
  const imageUrl = selectedFields[0].imageUrl
  const personStep = step == 'person'
  const fieldStep = step == 'field'
  const currencyName = currency && currency != 'usd' ? ` (${currency.toUpperCase()})` : ''

  const availableField = () => {
    const availableFields = selectedFields.filter(field => selectedInterval.fields.includes(field.id))
    return availableFields[0]
  }

  const fieldName = () => {
    const field = availableField()
    return [field.name, `Field #${field.number}`].filter(e => e).join(' | ')
  }

  const fieldDimentions = () => {
    return `${selectedSize}v${selectedSize}`
  }

  const amountLabel = (amount) => {
    return `$${amount.toFixed(2)}${currencyName}`
  }

  const fieldSize = () => {
    const fieldSizeLabel = `Field Size | ${fieldDimentions()}`
    return fieldSizeLabel + (price && !fieldStep ? ` | ${amountLabel(price)}` : '')
  }

  const timeInterval = () => {
    if (_.isEmpty(selectedInterval)) return ''

    const startTime = moment(selectedInterval.text, 'LT')
    const endTime = startTime.clone().add(selectedDuration, 'hours')
    return `${startTime.format('LT')} - ${endTime.format('LT')}`
  }

  const className = mobile ? 'mobile-only' : 'desktop-only'

  const fieldContent = () => {
    return <div className={`summary__info ${className}`} key='field'>
      <span><b>{fieldSize()}</b></span>
      { personStep && <span>{fieldName()}</span> }
    </div>
  }

  const timeContent = () => {
    const date = selectedDate.format('MMMM Do, YYYY')
    const time = timeInterval()
    const result = [date, time].filter(e => e).join(' | ')
    
    return <div className={`summary__info ${className}`} key='time'>
      <span><b>Date & Time</b></span>
      <span>{result}</span>
    </div>
  }

  const orderSummary = () => {
    const fieldLabel = [`${selectedDuration} Hours`, fieldDimentions(), fieldName()].join(' | ')

    return <div className={`summary__info ${className}`} key='time'>
      <h4>Order Summary</h4>
      <div className='summary__order'>
        <span>{fieldLabel}</span>
        <span>{amountLabel(price)}</span>
      </div>
      <div className='summary__order'>
        <span>Tax & Service Fee</span>
        <span>{amountLabel(totalFee)}</span>
      </div>
      <div className='summary__total'>
        <h4>Total</h4>
        <h4>{amountLabel(totalAmount)}</h4>
      </div>
    </div>
  }

  const content = () => {
    switch (step)
    {
      case 'field':
        return fieldContent()
      case 'time':
        return [fieldContent(), timeContent()]
      case 'person':
        return [fieldContent(), timeContent()]
      case 'payment':
        return orderSummary()
      default: 
        return null
    }
  }

  const desktopSummary = () => {
    return <div className='summary'>
      <div className='summary__image'><img src={imageUrl} /></div>
      {content()}
    </div>
  }

  const mobileSummary = () => {
    return <div className={'summary-mobile mobile-only' + (inline ? ' inline' : '')}>
      {content()}
    </div>
  }

  return mobile ? mobileSummary() : desktopSummary()
}

Summary.propTypes = {
  mobile: PropTypes.bool,
  inline: PropTypes.bool,
  step: PropTypes.string.isRequired,
  price: PropTypes.number,
  currency: PropTypes.string,
  fieldSizes: PropTypes.object.isRequired,
  selectedSize: PropTypes.string.isRequired,
  selectedDate: PropTypes.object.isRequired,
  selectedDuration: PropTypes.string.isRequired,
  selectedInterval: PropTypes.object.isRequired,
  totalAmount: PropTypes.number,
  totalFee: PropTypes.number,
}

export default Summary
